import { render, staticRenderFns } from "./MediaNewFolder.vue?vue&type=template&id=22a7597c&"
import script from "./MediaNewFolder.vue?vue&type=script&lang=ts&"
export * from "./MediaNewFolder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports